module.exports = __webpack_public_path__ + "img/3-low.e2e139f4.jpg";